<kl-report-filter2
  (onSelectReport)="selectReport($event)"
  (onCloseReport)="closeReport()"
  (onApplyReport)="applyReport($event)"
  (onClearAll)="clearAll()"
  (onCloseAlert)="alertShow = false"
  (onDeleteFromValues)="deleteFromValues($event)"
  (onDeleteSavedReport)="deleteSavedReport($event)"
  (onReportTypeChange)="report_type = $event"
  [report_title]="'license_documents_menu'"
  [parentModule]="'MATERIAL_MANAGEMENT'"
  [module]="'MATERIAL_STATUS_REPORT'"
  [key]="key"
  [type]="type"
  [haveAggregate]="true"
  [sourceData]="sourceData"
  [designList]="designList"
  [saveForm]="saveForm"
  [currentReport]="currentReport"
  [loadReport]="loadReport"
  [alertMessage]="alertMessage"
  [alertShow]="alertShow"
  [selectedReportFilterValues]="selectedReportFilterValues"
  [parentModuleName]="parentModuleName"
  [moduleName]="moduleName"
  [filter]="filter"
  [columns]="columns"
  [pivotRows]="pivotRows"
  [report_type]="report_type"
  [gridSettings]="gridSettings"
  [url]="url"
  [working_period_id]="working_period_id"
  [company]="company"
>
  <form #filterForm="ngForm">
    <div class="filter-group" #customerName>
      <div
        class="filter-group-heading ui-clickable"
        (click)="customerName.collapsed = !customerName.collapsed"
      >
        <p class="font-weight-light">
          {{ "customer_name" | translate }}
          <i
            class="fal"
            [ngClass]="{
              'fa-angle-up': customerName.collapsed,
              'fa-angle-down': !customerName.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!customerName.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="customer_name"
          #customerNameDropDown
          [(ngModel)]="customerNameExpressionValue"
          [options]="expressionOptions"
          [style]="{width: '90%'}"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="customerNameValue"
            #customerNameInput
            name="customer_name_input"
            class="form-control form-control-sm"
            maxlength="50"
          />
          <div class="input-group-append">
            <span
              class="input-group-text transparent"
              id="customer_name_span"
              (click)="
                setModal(
                  'customers',
                  'CUSTOMER_NAME',
                  CustomerListComponent,
                  '03.01.01',
                  false
                )
              "
            >
              <i class="fal fa-ellipsis-h"></i>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-group" #taxNum>
      <div
        class="filter-group-heading ui-clickable"
        (click)="taxNum.collapsed = !taxNum.collapsed"
      >
        <p class="font-weight-light">
          {{ "tax_num" | translate }}
          <i
            class="fal"
            [ngClass]="{
              'fa-angle-up': taxNum.collapsed,
              'fa-angle-down': !taxNum.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!taxNum.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="tax_num"
          #taxNumDropdown
          [(ngModel)]="taxNumExpressionValue"
          [options]="expressionOptions"
          [style]="{width: '90%'}"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="taxNumValue"
            #taxNumInput
            name="tax_num_input"
            class="form-control form-control-sm"
            maxlength="50"
          />
        </div>
      </div>
    </div>
    <div class="filter-group" #materialCode>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialCode.collapsed = !materialCode.collapsed"
      >
        <p class="font-weight-light">
          {{ "license_code" | translate }}
          <i
            class="fal"
            [ngClass]="{
              'fa-angle-up': materialCode.collapsed,
              'fa-angle-down': !materialCode.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!materialCode.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="material_code"
          #materialCodeDropdown
          [(ngModel)]="materialCodeExpressionValue"
          [disabled]="include(materialCodeValue, ',')"
          [options]="materialExpressionOptions"
          [style]="{width: '90%'}"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="materialCodeValue"
            #materialCodeInput
            name="material_code_input"
            class="form-control form-control-sm"
            maxlength="50"
            (keydown)="setModalWithF10('material_code_span', $event)"
          />
          <div class="input-group-append">
            <span
              class="input-group-text transparent"
              id="material_code_span"
              (click)="
                setModal(
                  'material',
                  'MATERIAL_CODE',
                  MaterialComponent,
                  '01.02.01',
                  false
                )
              "
            >
              <i class="fal fa-ellipsis-h"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #materialDescription>
      <div
        class="filter-group-heading ui-clickable"
        (click)="materialDescription.collapsed = !materialDescription.collapsed"
      >
        <p class="font-weight-light">
          {{ "license_description" | translate }}
          <i
            class="fal"
            [ngClass]="{
              'fa-angle-up': materialDescription.collapsed,
              'fa-angle-down': !materialDescription.collapsed
            }"
          ></i>
        </p>
      </div>
      <div
        class="filter-group-content"
        [collapse]="!materialDescription.collapsed"
      >
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="material_description"
          #materialDescriptionDropdown
          [(ngModel)]="materialDescriptionExpressionValue"
          [options]="materialExpressionOptions"
          [style]="{width: '90%'}"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="materialDescriptionValue"
            #materialDescriptionInput
            name="material_description_input"
            class="form-control form-control-sm"
            maxlength="50"
            (keydown)="setModalWithF10('material_description_span', $event)"
          />
          <div class="input-group-append">
            <span
              class="input-group-text transparent"
              id="material_description_span"
              (click)="
                setModal(
                  'material',
                  'MATERIAL_DESCRIPTION',
                  MaterialComponent,
                  '01.02.01',
                  false
                )
              "
            >
              <i class="fal fa-ellipsis-h"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-group" #licenseTypeCode>
      <div
        class="filter-group-heading ui-clickable"
        (click)="licenseTypeCode.collapsed = !licenseTypeCode.collapsed"
      >
        <p class="font-weight-light">
          {{ "license_type_code" | translate }}
          <i
            class="fal"
            [ngClass]="{
              'fa-angle-up': licenseTypeCode.collapsed,
              'fa-angle-down': !licenseTypeCode.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!licenseTypeCode.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="licenseTypeCode"
          #licenseTypeCodeDropdown
          [(ngModel)]="licenseTypeCodeExpressionValue"
          [options]="expressionOptions"
          [style]="{width: '90%'}"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="licenseTypeCodeValue"
            #licenseTypeCodeInput
            name="licence_key_input"
            class="form-control form-control-sm"
            maxlength="50"
          />
        </div>
      </div>
    </div>
    <div class="filter-group" #licenseKey>
      <div
        class="filter-group-heading ui-clickable"
        (click)="licenseKey.collapsed = !licenseKey.collapsed"
      >
        <p class="font-weight-light">
          {{ "license_key" | translate }}
          <i
            class="fal"
            [ngClass]="{
              'fa-angle-up': licenseKey.collapsed,
              'fa-angle-down': !licenseKey.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!licenseKey.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="licenseKey"
          #licenseKeyDropdown
          [(ngModel)]="licenseKeyExpressionValue"
          [options]="expressionOptions"
          [style]="{width: '90%'}"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="licenseKeyValue"
            #licenseKeyInput
            name="licence_type_code_input"
            class="form-control form-control-sm"
            maxlength="50"
          />
        </div>
      </div>
    </div>

    <div class="filter-group" #mainLicenseKey>
      <div
        class="filter-group-heading ui-clickable"
        (click)="mainLicenseKey.collapsed = !mainLicenseKey.collapsed"
      >
        <p class="font-weight-light">
          {{ "main_license_key" | translate }}
          <i
            class="fal"
            [ngClass]="{
              'fa-angle-up': mainLicenseKey.collapsed,
              'fa-angle-down': !mainLicenseKey.collapsed
            }"
          ></i>
        </p>
      </div>
      <div class="filter-group-content" [collapse]="!mainLicenseKey.collapsed">
        <p-dropdown
          [emptyFilterMessage]="'not_found' | translate"
          name="mainLicenseKeyDropDown"
          #mainLicenseKeyDropdown
          [(ngModel)]="mainLicenseKeyExpressionValue"
          [options]="expressionOptions"
          [style]="{width: '90%'}"
        ></p-dropdown>
        <div class="input-group" style="width: 90%">
          <input
            type="text"
            [(ngModel)]="mainLicenseKeyValue"
            #mainLicenseKeyInput
            name="main_licence_type_code_input"
            class="form-control form-control-sm"
            maxlength="50"
          />
        </div>
      </div>
    </div>
  </form>
</kl-report-filter2>
